export default __webpack_public_path__ + "static/media/download.4d03fc87.svg";